import { useTranslation } from 'react-i18next'


import * as spriteIcons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { useUserProfile } from 'store'

export const PayoutSettings = () => {
    const { t } = useTranslation()

    const profile = useUserProfile()!

    return (
        <>
            <ActionCard
                icon={<spriteIcons.IconCalendarOutline />}
                iconSize='small'
                text={t('payoutFrequency')}
                wireText={profile.payout_frequency && t(profile.payout_frequency)}
                hasArrow
                link='/settings/general/payout-settings/payment-frequency'
            />
            <ActionCard
                icon={<spriteIcons.IconWalletOutline />}
                iconSize='small'
                text={t('payoutMethod')}
                wireText={profile.payout_method ? t(profile.payout_method) : undefined}
                hasArrow
                link='/settings/general/payout-settings/payment-method'
            />

            <ActionCard
                icon={<spriteIcons.IconNoteOutline />}
                iconSize='small'
                text={t('uploadDocuments')}
                hasArrow
                link='/settings/general/payout-settings/upload-documents'
            />
        </>
    )
}
